import * as React from 'react';

import { CloseOutlined, FilterOutlined } from '@ant-design/icons';
import { Button, Col, Row } from 'antd';

import { Field, useFormikContext } from 'formik';
import { DateRangePickerFormField } from 'v2/components/Shared/FormFields/DateRangePicker';
import { SelectFormField } from 'v2/components/Shared/FormFields/SelectFormField';
import { SelectProduct } from 'v2/components/Shared/FormFields/SelectProduct';
import TextFormField from 'v2/components/Shared/FormFields/TextFormField';

export enum HistoryStatus {
  PENDING = 'pending',
  ARCHIVED = 'archived',
  SUCCESS = 'success',
  FAILED = 'failed'
}

export const FilterWebhookHistory = () => {
  const { resetForm, submitForm } = useFormikContext();

  const handleResetForm = () => {
    resetForm();
    submitForm();
  };

  return (
    <Row gutter={[16, 16]} align='bottom'>
      <Col xs={24} md={8}>
        <Field label='Data de envio' id='date' name='date' fullWidth component={DateRangePickerFormField} />
      </Col>

      <Col xs={24} md={8}>
        <Field
          id='webhook-historic-product'
          name='product_id'
          label='Produtos'
          fullWidth
          component={SelectProduct}
          endpoint='reports/filter-all-products?exclude_affiliations=1'
        />
      </Col>

      <Col xs={24} md={8}>
        <Field
          id='webhook-historic-customer'
          name='customer'
          label='Comprador'
          placeholder='Pesquise por nome ou email'
          fullWidth
          component={TextFormField}
        />
      </Col>

      <Col xs={24} md={6}>
        <Field
          id='entityId'
          name='entityId'
          component={TextFormField}
          fullWidth
          label='Fatura/Contrato'
          type='tel'
          placeholder='Pesquise por fatura ou contrato'
        />
      </Col>

      <Col xs={24} md={6}>
        <Field
          id='webhook-historic-status'
          name='status'
          label='Status'
          fullWidth
          component={SelectFormField}
          multiple
          options={[
            { label: 'Enviado', value: HistoryStatus.SUCCESS },
            { label: 'Retornou erro', value: HistoryStatus.FAILED },
            { label: 'Pendente', value: HistoryStatus.PENDING },
            { label: 'Arquivado', value: HistoryStatus.ARCHIVED }
          ]}
        />
      </Col>

      <Col xs={24} md={12}>
        <div className='flex items-center justify-end gap-3'>
          <Button type='text' onClick={handleResetForm} icon={<CloseOutlined />}>
            Limpar filtros
          </Button>
          <Button type='primary' htmlType='submit' icon={<FilterOutlined />}>
            Filtrar
          </Button>
        </div>
      </Col>
    </Row>
  );
};
